import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Operations } from 'src/app/_models/Operations/Operations';

@Component({
  selector: 'app-eventtypes-multi-select',
  templateUrl: './eventtypes-multi-select.component.html',
  styleUrls: ['./eventtypes-multi-select.component.scss']
})
export class EventtypesMultiSelectComponent implements OnInit {

  @Input() list: any[] = [];
  @Input() operation: number = Operations.Add;
  @Input() checkedItems: number[];
  @Input() title: string = "";

  @Output() shareCheckedList = new EventEmitter();

  checkedList: any[];

  constructor() {
    this.checkedList = [];
  }

  ngOnInit(): void {
    this.checkIfPopulated();
    this.shareCheckedlist();
  }

  checkIfPopulated() {
    if (this.checkedItems) {
      this.list.map((item) => {
        this.checkedItems.map((id) => {
          if (item.id == id) {
            this.checkedList.push(item.id);
          }
        })
      }
      );
    }
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }
}
